// SPDX-License-Identifier: AGPL-3.0-or-later

import {http} from '@app/features/platform/transport/RestTransport';
import {createContext, useContext} from 'react';

export interface DaoIMe {
	wallet_address: string | null;
	partner: {eligible: boolean | null; status: string; statusLabel?: string};
	partner_status: 'available' | 'unavailable';
}

export interface DaoICommunity {
	project_key: string;
	guild_id: string;
	discussion_id: string | null;
	announcement_id: string | null;
	voice_id: string | null;
}

export interface DaoIAsset {
	chain_id: number;
	address: string;
	symbol: string;
	name: string;
	decimals: number;
	balance: string | null;
	balance_status: string;
	price_usd: number | null;
	price_status: string;
	value_usd: number | null;
	logo_uri?: string;
}

export interface DaoIAssets {
	wallet: string;
	chain_id: number;
	assets: Array<DaoIAsset>;
	estimated_total_usd: number | null;
	valuation_complete: boolean;
	updated_at: string;
}

export interface DaoIContextValue {
	me: DaoIMe | null;
	communities: Array<DaoICommunity>;
	communitiesLoaded: boolean;
	pinnedGuildIds: Array<string>;
	refresh: () => void;
	setGuildPinned: (guildId: string, pinned: boolean) => Promise<void>;
	openBusiness: (view: 'mint' | 'swap' | 'partner') => void;
	openMessages?: () => void;
}

export const DaoIContext = createContext<DaoIContextValue | null>(null);

export function useDaoI(): DaoIContextValue {
	const context = useContext(DaoIContext);
	if (!context) throw new Error('DAOI application context is unavailable');
	return context;
}

export async function getDaoIData<T>(path: string, signal?: AbortSignal): Promise<T> {
	return (await http.get<T>(path, {signal})).body;
}
